import { SPEAKERS_SERVICE } from "@/services/occurences.service.js";

const state = {postOccurenceOutput: false, getOccurencesOutput: {}, putOccurenceOutput: false, getOccurenceDetailsOutput: {}, deleteOccurenceByIdOutput: false, getOccurenceBySlugOutput: {}, putOccurenceStatusOutput: {}};

const actions = {
    //Service to create occurences
    postOccurence({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postOccurenceRequest');
        
        SPEAKERS_SERVICE.postOccurence(input)
            .then(
                output => {
                    commit('postOccurenceSuccess', output);
                },
                error => {
                    commit('postOccurenceFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated occurences
    getOccurences({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getOccurencesRequest');

        SPEAKERS_SERVICE.getOccurences(queryParams)
            .then(
                output => {
                    commit('getOccurencesSuccess', output);
                },
                error => {
                    commit('getOccurencesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update occurences
    putOccurence({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putOccurenceRequest');

        SPEAKERS_SERVICE.putOccurence(input)
            .then(
                output => {
                    commit('putOccurenceSuccess', output);
                },
                error => {
                    commit('putOccurenceFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get occurence details
    getOccurenceDetails({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getOccurenceDetailsRequest');

        SPEAKERS_SERVICE.getOccurenceDetails(queryParams)
            .then(
                output => {
                    commit('getOccurenceDetailsSuccess', output);
                },
                error => {
                    commit('getOccurenceDetailsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete occurences
    deleteOccurenceById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteOccurenceByIdRequest');

        SPEAKERS_SERVICE.deleteOccurenceById(id)
            .then(
                output => {
                    commit('deleteOccurenceByIdSuccess', output);
                },
                error => {
                    commit('deleteOccurenceByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    //Service to update occurence status
    putOccurenceStatus({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putOccurenceStatusRequest');

        SPEAKERS_SERVICE.putOccurenceStatus(input)
            .then(
                output => {
                    commit('putOccurenceStatusSuccess', output);
                },
                error => {
                    commit('putOccurenceStatusFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postOccurence
    postOccurenceRequest(state) {
        state.postOccurenceOutput = null;
    },
    postOccurenceSuccess(state, output) {
        state.postOccurenceOutput = true;
    },
    postOccurenceFailure(state) {
        state.postOccurenceOutput = false;
    },

    //getOccurences
    getOccurencesRequest(state) {
    },
    getOccurencesSuccess(state, output) {
        state.getOccurencesOutput = output;
    },
    getOccurencesFailure(state) {
        state.getOccurencesOutput = false;
    },

    //putOccurence
    putOccurenceRequest(state) {
        state.putOccurenceOutput = null;
    },
    putOccurenceSuccess(state, output) {
        state.putOccurenceOutput = true;
    },
    putOccurenceFailure(state) {
        state.putOccurenceOutput = false;
    },

    //getOccurenceDetails
    getOccurenceDetailsRequest(state) {
    },
    getOccurenceDetailsSuccess(state, output) {
        state.getOccurenceDetailsOutput = output;
    },
    getOccurenceDetailsFailure(state) {
        state.getOccurenceDetailsOutput = false;
    },

    //deleteOccurenceById
    deleteOccurenceByIdRequest(state) {
        state.deleteOccurenceByIdOutput = null;
    },
    deleteOccurenceByIdSuccess(state, output) {
        state.deleteOccurenceByIdOutput = true;
    },
    deleteOccurenceByIdFailure(state) {
        state.deleteOccurenceByIdOutput = false;
    },

    //putOccurenceStatus
    putOccurenceStatusRequest(state) {
        state.putOccurenceStatusOutput = null;
    },
    putOccurenceStatusSuccess(state, output) {
        state.putOccurenceStatusOutput = true;
    },
    putOccurenceStatusFailure(state) {
        state.putOccurenceStatusOutput = false;
    },
};

export const occurences = {
    namespaced: true,
    state,
    actions,
    mutations
};